import { GLOBAL_SEARCH_OPENED } from 'constants/events';
import * as analytics from 'utilities/analytics';

import { HIDE_SEARCH_MODAL, SHOW_SEARCH_MODAL } from '../constants/actions';

export const hideSearchModal = () => {
  return { type: HIDE_SEARCH_MODAL };
};

export const showSearchModal = isShortcut => {
  analytics.track(GLOBAL_SEARCH_OPENED, {
    isShortcut: Boolean(isShortcut),
  });

  return {
    type: SHOW_SEARCH_MODAL,
  };
};
